// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sunzi__card-Rk6aA {
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 1px;
}
.sunzi__card-Rk6aA .sunzi__text-_ZhAA {
  font-weight: 600;
}
.sunzi__card-Rk6aA .sunzi__text-content-MaDsw {
  padding: 0 6px 9px;
}
.sunzi__card-selected-tRKA7 {
  background: var(--sunzi-theme-color-006), #ffffff;
  border: 2px solid var(--sunzi-theme-color);
  border-radius: 12px;
  padding: 0px;
}
.sunzi__card-selected-tRKA7 .sunzi__text-_ZhAA {
  font-weight: 800;
}
`, "",{"version":3,"sources":["webpack://./src/components/incementDrawer/DoubleSize/style.module.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,YAAA;AACF;AALA;EAMI,gBAAA;AAEJ;AARA;EASI,kBAAA;AAEJ;AAEA;EACE,iDAAA;EACA,0CAAA;EACA,mBAAA;EACA,YAAA;AAAF;AAJA;EAMI,gBAAA;AACJ","sourcesContent":[".card {\n  background: white;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 12px;\n  padding: 1px;\n  .text {\n    font-weight: 600;\n  }\n  .text-content {\n    padding: 0 6px 9px;\n  }\n}\n\n.card-selected {\n  background: var(--sunzi-theme-color-006), #ffffff;\n  border: 2px solid var(--sunzi-theme-color);\n  border-radius: 12px;\n  padding: 0px;\n  .text {\n    font-weight: 800;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `sunzi__card-Rk6aA`,
	"text": `sunzi__text-_ZhAA`,
	"text-content": `sunzi__text-content-MaDsw`,
	"textContent": `sunzi__text-content-MaDsw`,
	"card-selected": `sunzi__card-selected-tRKA7`,
	"cardSelected": `sunzi__card-selected-tRKA7`
};
export default ___CSS_LOADER_EXPORT___;
